module.exports = __webpack_public_path__ + "img/TvDip-blueprint.d63bcf.png";